export enum BlogStatusEnum {
  Active = 'Active',
  InActive = 'InActive',
  Draft = 'Draft',
  Internal = 'Internal',
}
